function logoAnimation(){
  var scroll = $(window).scrollTop();
  var logoTop = parseInt($('.Header__Logo.home').attr('data-top'));
  if(logoTop){

    if ($(window).width() < 641) {
      //var logoWidth = $(window).width() * 80 / 100;
      var logoWidth = 80;
      var logoLimit = 80;
      var logoWidth = 80;var logoLimit = 80;
      var logoDiff = 245;
      var logoAcc = 1.7;
      var logoTopLimit = 28;
    }
    else {
      var logoWidth = 400;
      var logoLimit = 90;
      var logoLimit = 90;;
      var logoDiff = 375;
      var logoAcc = 1.5;
    }
    
    
    var newTop = logoTop - scroll*logoAcc;
    var widthDiff = scroll*logoAcc/(logoTop-33)*logoDiff;
    var newWidth = logoWidth - widthDiff;
    if(newWidth < logoLimit){
      newWidth = logoLimit;
    }
    if ($(window).width() < 641) {
      if(newTop < logoTopLimit){
        newTop = logoTopLimit;
        newWidth = logoLimit;
      }
    }else{
      if(newTop < 35){
        newTop = 35;
        newWidth = logoLimit;
      }
    }
    
    if($(window).width() < 641) {
      if(scroll < 10){
        //newTop = $(window).height()*56/100;
        newTop = logoTopLimit;
        newWidth = logoWidth;
      }else if(scroll > logoTop){
        newTop = logoTopLimit;
        newWidth = logoLimit;
      }
      newTop = logoTopLimit;
    }
    $('.Header__Logo.home').css('width',newWidth+'px');
    $('.Header__Logo.home').css('top',newTop+'px');
  }
}
function closeCartDrawer(){
  $('#sidebar-cart').attr('aria-hidden', 'true');
  $(document).removeClass('no-scroll');
  disableBodyScroll(false, '[data-scrollable]');
  $('#shopify-section-header').css('z-index',''); // Ugly hack
  $('.PageOverlay').removeClass('is-visible');
  $('.PageOverlay').off('click');
  $('.Drawer__Close[data-drawer-id="sidebar-cart"]').off('click');
}

function addAddon() {
  var selectedAddon = $('.options-radio[name="properties[Addon Product]"]:checked');
  if (selectedAddon.length) {
    var variantID = selectedAddon.attr('data-id');
    return $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: { quantity: 1, id: variantID },
      dataType: 'json'
    });
  }
  return $.Deferred().resolve(); // No addon selected, resolve immediately
}

function addVase() {
  var selectedVase = $('.options-radio[name="properties[Vase Product]"]:checked');
  if (selectedVase.length) {
    var variantID = selectedVase.attr('data-id');
    return $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: { quantity: 1, id: variantID },
      dataType: 'json'
    });
  }
  return $.Deferred().resolve(); // No vase selected, resolve immediately
}
function addPackaging(){
  var productId = $('input[name="product-id"]').val();
  var selectedPackaging = $('.options-radio[name="properties[Packaging]"]:checked');
  var selectedNotecard = $('.options-radio[name="properties[Notecard]"]:checked');
  var variantID = selectedPackaging.attr('data-id');
  if(variantID){
    // const selectedVariant = $(`#product-select-${productId}`).val();
    var items = {quantity: 1,id: variantID};
    // var items = {
    //   quantity: 1,
    //   id: Number(selectedVariant)
    // };
    var notecardID = selectedNotecard.attr('data-id');
    if(notecardID){
      var items = {
        items:[
          {
        	quantity: 1,
        	id: variantID
          },
          {
        	quantity: 1,
        	id: notecardID
          }
        ]
      }
    };
    
    console.log(items);
    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: items,
      dataType: 'json',
      success: function() {
        var addonID = $('.options-radio[name="properties[Addon Product]"]:checked').attr('data-id');
        var vaseID = $('.options-radio[name="properties[Vase Product]"]:checked').attr('data-id');

        var promises = [];

        if (vaseID) {
          promises.push(addVase());
        }

        if (addonID) {
          promises.push(addAddon());
        }

        if (promises.length > 0) {
           $.when.apply($, promises).then(function() {
            $('.ProductForm__AddToCart').trigger('click');
          }).fail(function(xhr) {
            console.log(xhr.status);
          });
        } else {
          $('.ProductForm__AddToCart').trigger('click');
        }
      },
      error: function (xhr, ajaxOptions, thrownError) {
        return false;
        console.log(xhr.status);
        console.log(thrownError);
      }
    });
  }else{
    var addonID = $('.options-radio[name="properties[Addon Product]"]:checked').attr('data-id');
    var vaseID = $('.options-radio[name="properties[Vase Product]"]:checked').attr('data-id');

  	if (addonID || vaseID) {
      var promises = [];

      if (vaseID) {
        promises.push(addVase());
      }

      if (addonID) {
        promises.push(addAddon());
      }

      if (promises.length > 0) {
          $.when.apply($, promises).then(function() {
          $('.ProductForm__AddToCart').trigger('click');
        }).fail(function(xhr) {
          console.log(xhr.status);
        });
      }
    } else if ($('.ProductForm__AddToCart').is(":disabled")){
      $('.send-flower-submit span:first-child').text('Sold out');
    } else {
      $('.ProductForm__AddToCart').trigger('click');
    }
  }
}
function sendContactForm(){
  $.ajax({
    type: 'POST',
    dataType: 'json',
    url: '/contact#contact_form',
    data: $('.boutique-bouquets').serialize(),
    success: function() {
      $('.boutique-bouquets-submit span:first-child').text('request sent');
      $('.success-text').addClass('show');
      $('.error-text').hide();
    },
      error: function (xhr, ajaxOptions, thrownError) {
        $('.boutique-bouquets').addClass('captcha-error').submit();
        return false;
        console.log(xhr.status);
        console.log(thrownError);
      }
    });
}
function removeFirstItem(slideshow){
  if ($(window).width() < 641) {
    var el = slideshow.find(".three-images-item.first");
    slideshow.flickity( 'remove', el ); 
    window.tempElement = el;
  }else if(window.tempElement){
    slideshow.flickity( 'prepend', window.tempElement );
  }
}
function threeImagesSlider(){
  var threeImagesSlideshow = $('.three-images.slideshow');
    if(threeImagesSlideshow.length > 0){
      threeImagesSlideshow.each(function(){
        $(this).flickity({
          prevNextButtons: true,
          pageDots: false,
          wrapAround: true,
          adaptiveHeight: true,
          setGallerySize: false,
          contain: true,
          cellAlign: "left",
          ImagesLoaded: true,
          dragThreshold: 8,
          arrowShape: "M91.11,49.15H7.01l22.93-23.14l-0.71-0.7c-8.04,8.12-16.08,16.23-24.12,24.35c0.4,0.41,0.81,0.81,1.21,1.22 C13.95,58.58,21.59,66.29,29.22,74l0.71-0.7L7.01,50.15h84.1V49.15z",
          on: {
            ready: function() {
              var totalChildren = 4 / $(this)[0].cells.length * 100;
              $($(this)[0].$element[0]).next().find('.slider-bar-inner').css('width',totalChildren + '%');
            },
            change: function( index ) {
              var selectedIndex = $(this)[0].selectedIndex + 1;
              var totalPos = $(this)[0].slides.length;
              var sliderWidth = selectedIndex / totalPos * 100 ;
              $($(this)[0].$element[0]).next().find('.slider-bar-inner').css('width',sliderWidth + '%');
            }
          }
        });
        removeFirstItem($(this));
        var el = $(this);
        $(window).on('resize', function(){
          removeFirstItem(el);
        });
      });
    }
}

$(document).ready(function(){
  if (window.theme.showPageTransition) {
    $('.PageTransition').css('visibility','visible');
    $('.PageTransition').css('opacity',0);
  }
  $('.HorizontalList__Item[aria-haspopup="true"]').on('click', function(){
    $('.Header__Icon[data-drawer-id="sidebar-menu"]').trigger('click');
  });
  
  // Header Logo Animation Init
  var logoPos = parseInt($('.Header__Logo.home').css('top'));
  $('.Header__Logo.home').attr('data-top',logoPos);
  logoAnimation();
  
  
  // Moving Object
  if($('.text-with-moving-object').length){
    var movingObj = $('.moving-object');
    function moveObj(e) {
      if (e.type == "mousemove") {
        var x = e.pageX - $('.text-with-moving-object').offset().left;
	  	var y = e.pageY - $('.text-with-moving-object').offset().top - 100;
      } else if (e.type == "touchmove") {
        var touch = e.changedTouches[0];
        var x = touch.pageX - $('.text-with-moving-object').offset().left;
	  	var y = touch.pageY - $('.text-with-moving-object').offset().top - 100;
      }
      if(y < -26){
        y= -26;
      }else if(y > $('.text-with-moving-object').height()){
        y= $('.text-with-moving-object').height() - 100;
      }
      /*TweenMax.to(movingObj, 1.2, {
        css: {
          left: x,
          top: y
        },
        ease: Power1.easeOut
      });*/
      gsap.to(movingObj, 1.5, {
        left:0,
        top:0,
        x: x,
        y: y,
        ease: Power1.easeOut
      });
      
    }
    $('.text-with-moving-object').on({
      mousemove: moveObj,
      touchmove: moveObj
    });
  }

  function collectionSliderInit(el){
    if ($(window).width() < 641) {
      var continous = true;
      var alignCell = 'center';
      var aHeight = false;
    }else{
      var continous = false;
      var alignCell = 'left';
      var aHeight = false;
    }
    if(el.hasClass('flickity-enabled')){
      el.find('.ProductItem').each(function(){
        $(this).height('100%');
      });
      el.flickity('destroy');
    }
    if(!el.hasClass('flickity-enabled')){
      el.flickity({
        prevNextButtons: true,
        adaptiveHeight: aHeight,
        pageDots: true,
        wrapAround: continous,
        contain: true,
        cellAlign: alignCell,
        dragThreshold: 8,
        groupCells: true,
        arrowShape: "M91.11,49.15H7.01l22.93-23.14l-0.71-0.7c-8.04,8.12-16.08,16.23-24.12,24.35c0.4,0.41,0.81,0.81,1.21,1.22 C13.95,58.58,21.59,66.29,29.22,74l0.71-0.7L7.01,50.15h84.1V49.15z",
        on: {
          ready: function() {
            var totalChildren = 4 / $(this)[0].cells.length * 100;
            $($(this)[0].$element[0]).next().find('.slider-bar-inner').css('width',totalChildren + '%');
            $($(this)[0].$element[0]).find('.ProductItem').each(function(){
              $(this).height($(this).parent().height());
            });
          },
          select: function() {
            var totalChildren = 4 / $(this)[0].cells.length * 100;
            $($(this)[0].$element[0]).next().find('.slider-bar-inner').css('width',totalChildren + '%');
            $($(this)[0].$element[0]).find('.ProductItem').each(function(){
              $(this).height($(this).parent().height());
            });
          },
          change: function( index ) {
            var selectedIndex = $(this)[0].selectedIndex + 1;
            var totalPos = $(this)[0].slides.length;
            var sliderWidth = selectedIndex / totalPos * 100 ;
            $($(this)[0].$element[0]).next().find('.slider-bar-inner').css('width',sliderWidth + '%');
          }
        }
      });
    }
  }
  // Collection Slider
  var collectionSections = $('.collection-flickity');
  if(collectionSections.length > 0){
    collectionSections.each(function(){
      var collectionElement = $(this);
      collectionSliderInit(collectionElement);
      
      var windowWidth = $(window).width();
      $(window).resize(function(){
        if ($(window).width() != windowWidth) {
          collectionSliderInit(collectionElement);
        }
      });
    });
  }
  
  threeImagesSlider();
  
  
  // Add to Cart
  $(document).on('click','.quick-atc', function(){
    var productId = $(this).attr('data-product');
    $(this).attr('data-text',$(this).find('span').text()).find('span').text('adding to cart');
    var thisAtc = $(this);

    if(!$(this).hasClass('processing')){
      $(this).addClass('processing');
      $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: {
          quantity: 1,
          id: productId
        },
        dataType: 'json',
        success: function() {
    	  thisAtc.find('span').text(thisAtc.attr('data-text'));
          thisAtc.removeClass('processing');
          $.get("/cart?view=drawer", function(data, status){
            var newContents = $(data).find('.Cart').html();
            $('#sidebar-cart').find('.Cart').html(newContents);
            var cartCount = parseInt($('.Header__CartCount').text()) + 1;
            $('.Header__CartCount').text(cartCount);
          }).then(function () {
            $('#sidebar-cart').attr('aria-hidden', 'false');
            $('#sidebar-cart').css('max-height', window.innerHeight+'px');
            $(document).addClass('no-scroll');
            disableBodyScroll(true, '[data-scrollable]');
            $('#shopify-section-header').css('z-index',''); // Ugly hack
            $('.PageOverlay').addClass('is-visible');
            $('.PageOverlay').on('click',closeCartDrawer);
            $('.Drawer__Close[data-drawer-id="sidebar-cart"]').on('click',closeCartDrawer);
          });
        },
        error: function (xhr, ajaxOptions, thrownError) {
          console.log(xhr.status);
          console.log(thrownError);
        }
      });
    }
  });
  
  
  //Instagram Footer
  if($('.footer-instagram').length){
    var username = $('.footer-instagram').attr('data-username');
    $.instagramFeed({
      'username': username,
      'container': "#footer-instagram-photo",
      'display_profile': false,
      'display_biography': false,
      'display_gallery': true,
      'display_captions': false,
      'callback': null,
      'styling': true,
      'items': 6,
      'items_per_row': 6,
      'margin': 0,
      'lazy_load': true,
      'on_error': console.error
    });
  }
  
  
  var productPrice = parseInt($('.variant-summary.main-product .ProductMeta__Price').text().replace(/[^0-9]/g,''))*100;
  if($('.send-flower').length){
    $('.send-flower .variant-summary').each(function(){
      if($(this).attr('data-price')){
        var additionalPrice = parseInt($(this).attr('data-price'));
        productPrice = productPrice + additionalPrice; 
      }
    })
  }

  $(document).on('change', '.options-radio.SizeSwatch__Radio', function(){
    // waiting for logic from theme.js runs
    setTimeout(() => {
      const button = $('.send-flower-submit');
      if ($('.ProductForm__AddToCart').is(":disabled")) {
        button.find("span:first-child").text(window.languages.productFormSoldOut);
        button.prop("disabled", true);
      } else {
        button.prop("disabled", false);
      }

      if ($('.delivery-date-accordion') && $('.delivery-date-accordion').not('.opened')) {
        $('.delivery-date-accordion').addClass('opened');
      }
    }, 100);
  });
  
  $(document).on('change', '.options-radio:not(.SizeSwatch__Radio)', function(){
    var selectedValue = $(this).filter(':checked').val();
    var currentAccordion = $(this).parents('.product-options-accordion');
    var nextAccordion = $(this).parents('.product-options-accordion').next();
    
    if($('input[value="without notecard"]').is(':checked')){
      $('#product-note').prop( "disabled", true );
    }else{
      $('#product-note').prop( "disabled", false );
    }
    
    currentAccordion.find('.variant-options').text(selectedValue);
    var variantSummary = currentAccordion.find('.variant-summary');
    currentAccordion.addClass('checked');
    if(variantSummary.length){
      var dataPrice = $(this).filter(':checked').attr('data-price');
      variantSummary.attr('data-price',dataPrice);
      var additionalPrice = parseInt(dataPrice);
      
    }
    
    var productPrice = parseInt($('.variant-summary.main-product .ProductMeta__Price').text().replace(/[^0-9]/g,''))*100;
    
    if($('.send-flower').length){
      $('.send-flower .options-radio:checked').each(function(){
        if($(this).attr('data-price')){
          var additionalPrice = parseInt($(this).attr('data-price'));
          productPrice = productPrice + additionalPrice;
    	  
        }
      })
    }
    
    var formattedMoney = Shopify.formatMoney(productPrice, window.theme.moneyFormat)
    $('.send-flower-submit').find('[data-money-convertible]').text(formattedMoney);
    
    var totalHeight = 0;
    nextAccordion.children().each(function(){
      if(!$(this).hasClass('variant-summary')){
        totalHeight = totalHeight + $(this).outerHeight(true);
      }
    });
    $('.product-options-accordion').removeClass('opened');
    nextAccordion.height(totalHeight);
    nextAccordion.addClass('opened');
  });
  
  
  $(document).on('change', '.boutique-bouquets .contact-info input', function(){
    var filled = 0;
    var currentAccordion = $(this).parents('.product-options-accordion'); 
    var nextAccordion = $(this).parents('.product-options-accordion').next();
    $(this).parents('.contact-info').find('input').each(function(){
      if($(this).val() != ''){
        filled++;
      }
    });
    if(filled > 2){
      var totalHeight = 0;
      currentAccordion.addClass('checked');
      nextAccordion.children().each(function(){
        if(!$(this).hasClass('variant-summary')){
          totalHeight = totalHeight + $(this).outerHeight(true);
        }
      });
      $('.product-options-accordion').removeClass('opened');
      nextAccordion.height(totalHeight);
      nextAccordion.addClass('opened');
      $(this).parents('.product-options-accordion').find('.note').text('entered');
    }else if(filled < 1){
      $(this).parents('.product-options-accordion').find('.note').text('empty');
    }else{
      $(this).parents('.product-options-accordion').find('.note').text('not fully entered');
    }
  });
  
  
  // Datepicker
  $.fn.datepicker.language['en'] = {
    days: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
    daysShort: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
    daysMin: ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'],
    months: ['January','February','March','April','May','June', 'July','August','September','October','November','December'],
    monthsShort: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
    today: 'Today',
    clear: 'Clear',
    dateFormat: 'mm/dd/yyyy',
    timeFormat: 'hh:ii aa',
    firstDay: 0
  };
  if($('.delivery-date-picker').length){
  var datePickerConfig = JSON.parse($('.delivery-date-picker').attr('data-config'));
  var disabledDays = datePickerConfig.disabledDays;
  
  var startingDate = new Date();
  startingDate.setDate(startingDate.getDate() + parseInt(datePickerConfig.cutoff));
  
  var disabledDaysSpecific = datePickerConfig.disabledSpecific.split(',');
  
  
  $('.delivery-date-picker').datepicker({
    dateFormat : 'MM dd, yyyy',
    language : 'en',
    minDate : startingDate,
    onRenderCell: function (date, cellType) {
      if (cellType == 'day') {
        var day = date.getDay();
        var dayFormatted = date.getDate()+'/'+(parseInt(date.getMonth())+1)+'/'+date.getFullYear();
        var isDisabled = false;
        if(disabledDays.indexOf(day)!= -1){
          isDisabled = true;
        }else if(disabledDaysSpecific.indexOf(dayFormatted)!= -1){
          isDisabled = true;
        }
        return {
          disabled: isDisabled
        }
      }
    },
    onSelect: function(formattedDate, date, inst) {
      var el = $(inst.$el);
      var currentAccordion = el.parents('.product-options-accordion'); 
      var nextAccordion = el.parents('.product-options-accordion').next();
      if(el.val() != ''){
        var totalHeight = 0;
        currentAccordion.addClass('checked');
        nextAccordion.children().each(function(){
          if(!$(this).hasClass('variant-summary')){
            totalHeight = totalHeight + $(this).outerHeight(true);
          }
        });
        $('.product-options-accordion').removeClass('opened');
        nextAccordion.height(totalHeight);
        nextAccordion.addClass('opened');
        el.parents('.product-options-accordion').find('.note').text(el.val());  
      }else{
        el.parents('.product-options-accordion').find('.note').text('');
      }
      var datePickerData = el.data('datepicker');
	  datePickerData.hide();
    }
  })
  }
  
  
  $(document).on('click', '.send-flower-submit', function(){
    if($('.send-flower').length){
      const isNoDesignReferenceChecked = $('.options-radio[name="properties[Design Reference]"]').length > 0 && $('.options-radio[name="properties[Design Reference]"]:checked').length === 0;
      if($('.options-radio.SizeSwatch__Radio:checked').length == 0 || $('input[name="properties[Delivery Date]"]').val() == '' || isNoDesignReferenceChecked){
        $('.error-text').text('Please select all required (*) options');
      }else{
        if($('.options-radio[name="properties[Packaging]"]').length && $('.options-radio[name="properties[Packaging]"]:checked').length == 0){
          $('.error-text').text('Please select all required (*) options');
        }else{
          $('.error-text').hide();
          $(this).find('span:first-child').text('adding to cart');
          addPackaging();
        }
      }
    }
  });
  
  $(document).on('submit', '.boutique-bouquets', function(e,c){
    if(!$(this).hasClass('captcha-error')){
      e.preventDefault();
      if($('.boutique-bouquets').length){
        if($('#contact-name').val() == '' || $('#contact-email').val() == '' || $('input[name="contact[Delivery Date]"]').val() == '' || $('#contact-phone').val() == ''){
          $('.error-text').text('Please select all required (*) options');
          $('.success-text').removeClass('show');
        }else{
          $('.error-text').hide();
          $(this).find('.boutique-bouquets-submit span:first-child').text('sending request...');
          sendContactForm();
        }
      }
    }else{
      return;
    }
  });
  
  function setAccordionHeight(){
    if($('.product-options-accordion.opened').length){
      var totalHeight = 0;
      $('.product-options-accordion.opened').children().each(function(){
        if(!$(this).hasClass('variant-summary')){
          totalHeight = totalHeight + $(this).outerHeight(true);
        }
      });
      $('.product-options-accordion.opened').height(totalHeight);
    }
  }
  
  function runOnceOnScroll(callback) {
    function onScroll() {
      callback();
      window.removeEventListener('scroll', onScroll); // Remove the event listener after the first execution
    }
  
    window.addEventListener('scroll', onScroll);
  }
  
  // Usage:
  let hasRun = false;
  $(window).on('scroll', function () {
    if (!hasRun) {
      hasRun = true;
      setAccordionHeight();
    }
  });
  
  
  $('.product-options-accordion input').attr('checked', false);
  $('.single-product-options input').attr('checked', false);
  $('.send-flower-submit').find('[data-money-convertible]').text('AED 0');
  $('.product-options-accordion .ProductForm__Label').not('.always-opened').on('click', function(){
    var accordion = $(this).parent();
    if(accordion.hasClass('opened')){
      accordion.removeClass('opened');
    }else{
      var totalHeight = 0;
      accordion.children().each(function(){
        if(!$(this).hasClass('variant-summary')){
          totalHeight = totalHeight + $(this).outerHeight(true);
        }
      });
      $('.product-options-accordion').not('.always-opened').removeClass('opened');
      accordion.height(totalHeight);
      accordion.addClass('opened');
    }
  })
  
  
  $(document).on('keyup', '#product-note', function(){
    var noteValue = $(this).val();
    var currentAccordion = $(this).parents('.product-options-accordion'); 
    if(noteValue != ''){
      $(this).parents('.product-options-accordion').find('.note').text('written');
      currentAccordion.addClass('checked');
    }else{
      $(this).parents('.product-options-accordion').find('.note').text('empty');
    }
  });
  
  //Menu Image
  $('.menu-image-link').mouseenter(function () {
    var images_html = $(this).parent().find('.menu-images-list').html();
    $('.menu-images-display').html(images_html).show();
  });

 $('#hover_tutor_hidden').mouseleave(function () {
    $('.menu-images-display').hide().html('');
 }).mouseleave();
  
  $('#marquee-gallery').slick({
    speed: 5000,
    autoplay: true,
    autoplaySpeed: 0,
    centerMode: false,
    cssEase: 'linear',
    slidesToShow: 1,
    slidesToScroll: 1,
    variableWidth: true,
    infinite: true,
    initialSlide: 2,
    arrows: false,
    buttons: false
  });
  
  
});

function headerBackground(){
  var scroll = $(window).scrollTop();
  if($('.shopify-section--slideshow').length){
    if(scroll > $('.shopify-section--slideshow').first().height()){
      $('#section-header').css('background-color','white').addClass('has-background');
    }else{
      $('#section-header').css('background-color','transparent').removeClass('has-background');
    }
  }else{
    if(scroll > $('#section-header').height()){
      $('#section-header').css('background-color','white').addClass('has-background');;
    }else{
      $('#section-header').css('background-color','transparent').removeClass('has-background');;
    }
  }
}

function headerOffset(){
  var headerHeight = $('#section-header').outerHeight();
  if(!$('body').hasClass('template-index')){
    $('#main').css('padding-top',headerHeight);
  }
}
headerOffset();
// Header Logo Animation on Scroll
$(window).scroll(function (event) {
  logoAnimation();
  headerBackground();
});

const lw = $(window).width();
$(window).on('resize', function(){
  if($(window).width() != lw){
    setAccordionHeight();
    logoAnimation();
    threeImagesSlider();
    headerOffset();
    if($('.collection-flickity .ProductItem').length){
      $('.collection-flickity .ProductItem').each(function(){
        $(this).outerHeight($(this).find('.ProductItem__Wrapper a').outerHeight() + 20);
        $(this).parents('.flickity-viewport').outerHeight($(this).outerHeight() + 65);
      })
    }
    lw = $(window).width();
  }
});

